import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function SectionHeader({ eyebrow, title, accent, cta, ctaTo, ctaHref, description }) {
  return (
    <div className="max-w-7xl mx-auto px-6 mb-12 md:mb-16">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div className="max-w-3xl">
          <div className="eyebrow-row">
            <span className="eyebrow">{eyebrow}</span>
          </div>
          <h2 className="display text-4xl md:text-5xl lg:text-6xl mt-5">
            {title}{accent ? <> <span className="rainbow-text">{accent}</span></> : null}
            <span className="text-white/30">.</span>
          </h2>
          {description ? (
            <p className="mt-5 text-base md:text-lg text-white/60 max-w-2xl leading-relaxed">
              {description}
            </p>
          ) : null}
        </div>
        {cta && (ctaTo || ctaHref) ? (
          ctaTo ? (
            <Link to={ctaTo} className="btn-pill btn-secondary self-start md:self-end" data-testid="section-cta">
              {cta} <ArrowUpRight size={16} />
            </Link>
          ) : (
            <a href={ctaHref} target="_blank" rel="noopener noreferrer" className="btn-pill btn-secondary self-start md:self-end" data-testid="section-cta">
              {cta} <ArrowUpRight size={16} />
            </a>
          )
        ) : null}
      </div>
    </div>
  );
}

export function PageHero({ eyebrow, title, accent, subtitle, children }) {
  return (
    <section className="relative pt-16 md:pt-24 pb-12 md:pb-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="eyebrow-row fade-in-up">
          <span className="eyebrow">{eyebrow}</span>
        </div>
        <h1 className="display mt-6 text-5xl sm:text-6xl md:text-7xl lg:text-8xl fade-in-up delay-1" data-testid="page-hero-title">
          {title}
          {accent ? <> <span className="rainbow-text">{accent}</span></> : null}
        </h1>
        {subtitle ? (
          <p className="mt-6 text-base md:text-xl text-white/65 max-w-2xl leading-relaxed fade-in-up delay-2">
            {subtitle}
          </p>
        ) : null}
        {children ? <div className="mt-10 fade-in-up delay-3">{children}</div> : null}
      </div>
    </section>
  );
}
